module.exports = __webpack_public_path__ + "static/media/spiky_dj_tag_2.77800a5a.mp3";